module.exports = __webpack_public_path__ + "img/位图(2).7b19779a.png";